import { Icon, MinimalIconProps } from '@ardoq/icons';
import { Button, ButtonType } from '@ardoq/button';
import { getSymbolShortcutString } from './ShortcutKey';

export type ToolbarButtonProps = {
  isDisabled?: boolean;
  isActive: boolean;
  onClick: () => void;
  children?: React.ReactNode;
  icon: MinimalIconProps;
  tooltipText: string;
  hasError?: boolean;
  shortcuts?: string[];
};

export const ToolbarButton = ({
  isDisabled,
  isActive,
  onClick,
  icon,
  tooltipText,
  hasError,
  shortcuts,
}: ToolbarButtonProps) => {
  const shortcutKeys = shortcuts
    ? ` ${getSymbolShortcutString(shortcuts)}`
    : '';
  return (
    <Button
      data-tooltip-text={isDisabled ? undefined : tooltipText + shortcutKeys}
      isDisabled={isDisabled}
      buttonType={ButtonType.GHOST}
      onClick={onClick}
      isActive={!isDisabled && isActive}
      aria-label={tooltipText + shortcutKeys}
      hasError={hasError}
    >
      <Icon
        iconName={icon.name}
        color={icon.color}
        style={{ color: icon.color }}
      />
    </Button>
  );
};
